import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import LoaderSpinner from '../../../../../components_v2/common/LoaderSpinner/LoaderSpinner';
import { gaWrapper } from '../../../../../helpers/analytics';
import Cookie from '../../../../../utils/cookies';
import makeRequest from '../../../../../utils/makeRequest';
import QuestionWrapper from '../QuestionWrapper/QuestionWrapper';
import s from './Survey.scss';
import SurveySuccess from './SurveySuccess';
import SocialSharing from '../../../../articleshow_v2/components/common/SocialWidget/SocialWidget';

const Survey = props => {
  const { name, subName, partnerIcon, isCategory, msid, path, wu, submitURL } =
    props.sectionItem || {};
  const { questions } = props || [];
  const gaBudgetCommon = ['send', 'event', 'budget_survey'];
  const [activeQuestion, setActiveQuestion] = useState(0);
  const [snackbarDescription, setSnackbarDescription] = useState(null);
  const [answers, setAnswers] = useState({});
  const [success, setSuccess] = useState(0);
  const [requiredToast, setRequiredToast] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isCategory) {
      gaWrapper(
        ...gaBudgetCommon,
        'category_selection_screen',
        'survey_initiated',
      );
    } else {
      gaWrapper(...gaBudgetCommon, `survey_screen_${msid}`, 'survey_selected');
    }
  }, []);

  useEffect(
    () => {
      setRequiredToast(false);
    },
    [activeQuestion],
  );

  const hideRequiredToast = () => {
    if (requiredToast) {
      setRequiredToast(false);
    }
  };

  const submitSurvey = () => {
    setIsLoading(true);
    const submitAnswers = [];
    const userIdentifier = {
      ssoid: '',
    };

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (const key in answers) {
      submitAnswers.push({
        optionSelected: [...answers[key]],
        questionId: key,
      });
    }

    userIdentifier.ssoid = Cookie.get('ssoid') || Cookie.get('_grx') || '';

    const quizSubmitData = {
      answers: submitAnswers,
      hostId: questions[activeQuestion].hostid,
      quizForm: {},
      quizId: msid,
      userIdentifier,
    };

    try {
      makeRequest.post(submitURL, quizSubmitData).then(res => {
        if (!res?.data?.error) {
          setSuccess(1);
          setIsLoading(false);
          gaWrapper(...gaBudgetCommon, 'thank_you_screen', 'survey_submitted');
        } else {
          setSuccess(-1);
          setIsLoading(false);
          gaWrapper(...gaBudgetCommon, 'already_filled', 'survey_submitted');
        }
      });
    } catch (error) {
      Error('Request Error');
    }
  };

  const changeQuestion = (active, navigation = 0) => {
    if (navigation === -1) {
      setActiveQuestion(activeQuestion - 1);
      gaWrapper(...gaBudgetCommon, `previous_${activeQuestion + 1}`, 'enabled');
    } else if (activeQuestion < questions?.length && active) {
      setActiveQuestion(activeQuestion + 1);
      setRequiredToast(false);
      gaWrapper(...gaBudgetCommon, `next_${activeQuestion + 1}`, 'enabled');
    } else {
      setRequiredToast(true);
      gaWrapper(...gaBudgetCommon, `next_${activeQuestion + 1}`, 'disabled');
    }
  };

  const onSubmit = active => {
    if (activeQuestion === questions?.length - 1 && !active) {
      setRequiredToast(true);
      if (isCategory) {
        gaWrapper(...gaBudgetCommon, `procees_to_survey`, 'disabled');
        return;
      }
      gaWrapper(...gaBudgetCommon, `submit_${activeQuestion + 1}`, 'disabled');
      return;
    }
    if (isCategory && active) {
      setIsLoading(true);
      window.open(`${wu}/${answers?.category}`, '_self');
      setIsLoading(false);
      gaWrapper(...gaBudgetCommon, `procees_to_survey`, 'enabled');
    } else if (active) {
      submitSurvey();
      gaWrapper(...gaBudgetCommon, `submit_${activeQuestion + 1}`, 'enabled');
    }
  };

  const handleSnackBar = (title, detail) => {
    setSnackbarDescription({ title, detail });
  };

  const onChangeOptions = (e, selected) => {
    let newAnswers = {};
    if (e.target.type === 'checkbox') {
      if (answers[e.target.name]) {
        newAnswers = {
          ...answers,
          [e.target.name]: selected.reduce(
            (values, item) => [...values, item.value],
            [],
          ),
        };
      } else {
        newAnswers = {
          ...answers,
          [e.target.name]: [e.target.value],
        };
      }
    } else {
      newAnswers = { ...answers, [e.target.name]: e.target.value };
    }
    if (requiredToast) {
      setRequiredToast(false);
    }
    setAnswers(newAnswers);
  };

  return (
    <div className={s.surveyWrap}>
      <div
        className={`${s.surveyHeader} ${isCategory ? s.surveyHeaderShare : ''}`}
      >
        <h2>
          {name} <span>{subName}</span>
        </h2>
        {isCategory && (
          <div className={s.shareBox}>
            <div className={s.shareTitle}>Share with Friends</div>
            <SocialSharing
              title="What are your expectations in the run up to Budget 2023? Take this TOI-Deloitte survey"
              url={wu}
              wu={wu}
              via="@timesofindia"
              isTablet
              whatsAppShow
              isWapView={props.isWapView}
              wrapperClass=""
              gaCategory="budget_survey"
              gaIndex="share_"
              gaAction="click_share"
              defaultEmailView
              disableShortUrl
            />
          </div>
        )}
        <div className={s.partnerWrap}>
          <img src={partnerIcon} alt="partner" />
        </div>
      </div>

      {isLoading && <LoaderSpinner />}

      {success === 0 ? (
        <form className={s.surveyForm}>
          <QuestionWrapper
            isWapView={props.isWapView}
            question={questions[activeQuestion]}
            handleSnackBar={handleSnackBar}
            isCategory={isCategory}
            onChangeOptions={onChangeOptions}
            onHandleChangeQuestion={changeQuestion}
            onHandleSubmit={onSubmit}
            totalQuestions={questions.length}
            activeQuestion={activeQuestion}
            requiredToast={requiredToast}
            answers={answers}
            hideRequiredToast={hideRequiredToast}
          />
        </form>
      ) : (
        <SurveySuccess
          isWapView={props.isWapView}
          title={
            success === 1
              ? 'Thank you for participating'
              : `You have already answered this survey`
          }
          subtitle={
            success === 1
              ? `We appreciate you taking the time for filling up the survey, as your input
        will immensely help us in building budget 2023 experience.`
              : `You have already submitted responses to this survey. Only your original responses will be included in the results`
          }
          path={path}
          wu={wu}
        />
      )}

      {props.isWapView &&
        isCategory &&
        snackbarDescription && (
          <div className={s.bottomPopup}>
            <div className={s.bpContent}>
              <div className={s.bpTitle}>{snackbarDescription.title}</div>
              {snackbarDescription.detail}
              <span
                onClick={() => {
                  setSnackbarDescription(null);
                }}
                className={s.bpClose}
              />
            </div>
          </div>
        )}
    </div>
  );
};

Survey.propTypes = {
  sectionItem: PropTypes.objectOf({}),
  isWapView: PropTypes.bool,
};

Survey.defaultProps = {
  sectionItem: {},
  isWapView: false,
};

export default React.memo(Survey);
